import crud from './_crud'
import { callApi } from 'utils/api'
import { showSuccessMessage } from 'utils/messages'

const createBank = (item, options) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/bank/create_bank`, {
      method: 'POST',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({
        bank: item,
      }),
      successMessage: `Se agregó el banco correctamente.`,
    })

    showSuccessMessage('Los bancos se registraron correctamente')
    dispatch({
      type: 'ADD_BANK',
      response: res.body,
    })

    return res.body
  }
}

const updateBank = (item, options) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/bank/update_bank`, {
      method: 'POST',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({
        bank: item,
      }),
      successMessage: `Se editó el banco correctamente.`,
    })

    showSuccessMessage('Los bancos se editaron correctamente')
    dispatch({
      type: 'UPDATE_BANK',
      response: res.body,
    })

    return res.body
  }
}

const actions = crud('bank', 'el banco', 'los bancos')

export default { ...actions, createBank, updateBank }
